import React from "react";
export default function PageHeader({ title, description, children }) {
  return (
    <header className="card" style={{ marginBottom: 12 }}>
      <div className="h2" aria-live="polite">
        {title}
      </div>
      {description && (
        <p className="sm muted" style={{ marginTop: 6 }}>
          {description}
        </p>
      )}
      {children && <div style={{ marginTop: 10 }}>{children}</div>}
    </header>
  );
}
